import LoginConfig from "../../Utility/Config";
const Config = ({  
  baseURL: LoginConfig.baseURL,  
  extendedUrl: 'api/v1/',
  extendedUrlAuth: 'api/v1/auth/',
  environment: 'development',
  lastUpdate:'06/06/2023 10:40 AM',
  app_env: 'development',
  thumbnailSize: {
    size_width: 200,
    size_height: 200
  },
  planningEditableBeforeCurrentDay: 0,
  pageDataLimit: 10
});

export default Config;